import type { FieldDiaryFarm, FieldDiaryPropertySource } from '../types';

export function toFieldDiaryFarm(
	property: FieldDiaryPropertySource,
	ownerId?: string
): FieldDiaryFarm {
	return {
		_id: property._id,
		name: property.name,
		city: property.address?.city ?? '',
		state: property.state ?? '',
		avatarUrl: property.avatar?.url,
		ownerId,
	};
}

export function formatFarmLocation(farm: FieldDiaryFarm): string {
	return [farm.city, farm.state].filter(Boolean).join(', ');
}
